import React from "react";
import Button from "@irati/ui/src/Button";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import { H5 } from "@irati/ui/src/Typography";
import { ListItemWithActions } from "./styled";
var ListItem = function (_a) {
    var item = _a.item, hide = _a.hide, show = _a.show, edit = _a.edit, formatMessage = _a.formatMessage;
    var name = item.default ? formatMessage({ id: item.name }) : item.name;
    var iconHref = item.default ? formatMessage({ id: item.icon.href }) : item.icon.href;
    var iconAlt = item.default ? formatMessage({ id: item.icon.alt }) : item.icon.alt;
    return (React.createElement(ListItemWithActions, null,
        React.createElement(Flex, { alignItems: "center" },
            React.createElement("img", { src: iconHref, alt: iconAlt }),
            React.createElement(H5, null, item.default ? React.createElement(FormattedMessage, { id: name }) : item.name)),
        React.createElement(Flex, null,
            !item.default && edit && (React.createElement(Button, { marginLeft: 2, small: true, onClick: function () { return edit(item); } },
                React.createElement(FormattedMessage, { id: "admin.occasions.buttons.edit.label" }))),
            item.archived ? (React.createElement(Button, { marginLeft: 2, small: true, onClick: function () { return show(item); } },
                React.createElement(FormattedMessage, { id: "admin.occasions.buttons.show.label" }))) : (React.createElement(Button, { marginLeft: 2, small: true, onClick: function () { return hide(item); } },
                React.createElement(FormattedMessage, { id: "admin.occasions.buttons.hide.label" }))))));
};
export default injectIntl(ListItem);
